<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="true"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Importeren</h1>
        </div>
        <div class="controls">
            <a
                class="fab small me-3"
                href="https://app.vvr.nl/backend/public/templates/VVR_Import_template.xlsx"
                id="btn-template"
                matTooltip="Download template"
                matTooltipPosition="below"
                target="_blank">
                <i class="fas fa-file-excel"></i>
            </a>
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/customer-selection">
                <i class="fas fa-sign-out-alt"></i>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div>
                @if (customerAreas()) {
                    <ng-select
                        (ngModelChange)="selectedCustomerAreaId.set($event)"
                        [items]="customerAreas()"
                        [clearSearchOnAdd]="true"
                        [hideSelected]="true"
                        [ngModel]="selectedCustomerAreaId()"
                        bindLabel="name"
                        bindValue="id"
                        id="customerareas"
                        placeholder="Importeer voor gemeente">
                    </ng-select>
                }
            </div>
            @if (selectedCustomerAreaId()) {
                <div>
                    <button color="primary" mat-raised-button>
                        <label>
                            {{pushpinImportFinished() ? 'Upload bijbehorende Afbeeldingen' : 'Selecteer een excel sheet'}}
                            <input (change)="uploadFile($event)" hidden multiple type="file">
                        </label>
                    </button>
                    <br><br>
                    @for (file of uploadingFiles(); track file) {
                        <div>
                            @if (!file['partsWithError'] && file['uploading']) {
                                <div>
                                    Bezig met het importeren van '{{file.file}}'
                                </div>
                                <mat-progress-bar [value]="file['uploading']" mode="determinate"></mat-progress-bar>
                            }
                            @if (!file['partsWithError'] && !file['uploading']) {
                                <div>
                                    <b>'{{file.file}}' is geïmporteerd</b>
                                    @if (!file['img']) {
                                        @if (pushpinImportFinished()) {
                                            <div>
                                                <p>
                                                    Upload nu de afbeeldingen met de namen die u aangegeven hebt in de colom image
                                                    in de Excel sheet.
                                                    U kunt de afbeeldingen in het venster slepen of deze selecteren door op de knop
                                                    'Upload bijbehorende
                                                    Afbeeldingen' te klikken.
                                                </p>
                                                <p>
                                                    Verwachte afbeeldingen: {{file['imgs']}}
                                                    @if (!file['imgs']) {
                                                        Geen
                                                    }
                                                </p>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                            @if (file['partsWithError']) {
                                <div>
                                    <b>Fout bij het importeren van '{{file.file}}'</b>
                                    <br><br>
                                </div>
                                <div>
                                    <b>Corrigeer de volgende velden: </b>
                                    <table>
                                        <tr>
                                            <th>Kolom</th>
                                            <th>Waarde</th>
                                            <th>Correctie</th>
                                        </tr>
                                        @for (error of file['uniqueErrors']; track error) {
                                            <tr>
                                                <td>
                                                    {{file['nameMap'][file['columnMap'][error['columnWithError']]]}}
                                                </td>
                                                <td>
                                                    {{error['row'][error['columnWithError']]}}
                                                </td>
                                                <td>
                                                    @if (error['columnNameWithError'] != 'decoration_id') {
                                                        <input [(ngModel)]="error['row'][error['columnWithError']]" class="correction-field"
                                                               type="text">
                                                    }
                                                    @if (error['columnNameWithError'] == 'decoration_id') {
                                                        @if (decorations()) {
                                                            <ng-select
                                                                (change)="valueChanged(file, $event, error['row'][error['columnWithError']])"
                                                                [clearSearchOnAdd]="true"
                                                                [hideSelected]="true"
                                                                [items]="decorations()"
                                                                bindLabel="name"
                                                                bindValue="id"
                                                                class="correction-field"
                                                                groupBy="decoration_group"
                                                                placeholder="Selecteer een figuratie">
                                                                <ng-template
                                                                    let-index="index"
                                                                    let-item="item"
                                                                    let-search="searchTerm"
                                                                    ng-option-tmp>
                                                                    {{item.id}}. {{item.name}}
                                                                </ng-template>
                                                            </ng-select>
                                                        }
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </table>
                                </div>
                                <div>
                                    <button (click)="correctErrors(file)" color="primary" mat-raised-button>
                                        Corrigeer fouten
                                    </button>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>

